import axios from "./axios";

/** Current user's own profile. Admins may pass `{ user_id }` to view on behalf of another company user. */
export async function fetchProfile(params = {}) {
  return axios
    .get(`/profile`, { params })
    .then((response) => response.data)
    .catch((error) =>
      Promise.reject(error.response?.data || { error: true })
    );
}

/**
 * Patch the profile. `payload` must follow the locked contract shape:
 * { user: { ...editable fields, user_children, user_next_of_kins }, user_id? }
 */
export async function updateProfile(payload) {
  return axios
    .patch(`/profile`, payload)
    .then((response) => response.data)
    .catch((error) =>
      Promise.reject(error.response?.data || { error: true })
    );
}

/** Change history. Admins may pass `{ user_id }`. */
export async function fetchProfileVersions(params = {}) {
  return axios
    .get(`/profile/versions`, { params })
    .then((response) => response.data)
    .catch((error) =>
      Promise.reject(error.response?.data || { error: true })
    );
}

/** Revert/restore a previous version. Admins may pass `{ user_id }` for any company user. */
export async function revertProfileVersion(versionId, payload = {}) {
  return axios
    .post(`/profile/versions/${versionId}/revert`, payload)
    .then((response) => response.data)
    .catch((error) =>
      Promise.reject(error.response?.data || { error: true })
    );
}
